import React from "react";



const DatePickerCustomDay= ({ dayOfMonth, date }) => {
  return <span className="react-datepicker__day_span">{dayOfMonth}</span>;
};

export default DatePickerCustomDay;
